/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const productById = /* GraphQL */ `
  query ProductById($id: String!) {
    productById(id: $id) {
      id
      shirtDesignFront
      shirtDesignBack
      shirtColor
      shirtCategory {
        webflowId
        id
        categoryName
        name
      }
      shirtrealName {
        name
        id
      }
      sellingPrice
      realprice
      days
      target
      noOfCampaigns
      brief
      shirtName
      detail
      designShirt
      designShirtBack
      frontDesign {
        id
        width
        height
        x
        y
      }
      backDesign {
        id
        width
        height
        x
        y
      }
      customerId
      frontImg
      backImg
      color
      quantity
      step
      isDone
      weflowProductId
      weflowProductURL
      isStop
      orders {
        items {
          productId
          price
          quantity
          acceptedOn
          id
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const getProductTable = /* GraphQL */ `
  query GetProductTable($id: ID!) {
    getProductTable(id: $id) {
      id
      shirtDesignFront
      shirtDesignBack
      shirtColor
      shirtCategory {
        webflowId
        id
        categoryName
        name
      }
      shirtrealName {
        name
        id
      }
      sellingPrice
      realprice
      days
      target
      noOfCampaigns
      brief
      shirtName
      detail
      designShirt
      designShirtBack
      frontDesign {
        id
        width
        height
        x
        y
      }
      backDesign {
        id
        width
        height
        x
        y
      }
      customerId
      frontImg
      backImg
      color
      quantity
      step
      isDone
      weflowProductId
      weflowProductURL
      isStop
      orders {
        items {
          productId
          price
          quantity
          acceptedOn
          id
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProductTables = /* GraphQL */ `
  query ListProductTables(
    $filter: ModelproductTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        shirtDesignFront
        shirtDesignBack
        shirtColor
        shirtCategory {
          webflowId
          id
          categoryName
          name
        }
        shirtrealName {
          name
          id
        }
        sellingPrice
        realprice
        days
        target
        noOfCampaigns
        brief
        shirtName
        detail
        designShirt
        designShirtBack
        frontDesign {
          id
          width
          height
          x
          y
        }
        backDesign {
          id
          width
          height
          x
          y
        }
        customerId
        frontImg
        backImg
        color
        quantity
        step
        isDone
        weflowProductId
        weflowProductURL
        isStop
        orders {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebfloworders = /* GraphQL */ `
  query GetWebfloworders($id: ID!) {
    getWebfloworders(id: $id) {
      productId
      price
      quantity
      acceptedOn
      id
    }
  }
`;
export const listWebfloworderss = /* GraphQL */ `
  query ListWebfloworderss(
    $filter: ModelwebflowordersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebfloworderss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        productId
        price
        quantity
        acceptedOn
        id
      }
      nextToken
    }
  }
`;
export const getCardInfo = /* GraphQL */ `
  query GetCardInfo($id: ID!) {
    getCardInfo(id: $id) {
      id
      userId
      userName
      email
      city
      region
      postalCode
      country
      phoneNo
      cardNum
      address
      customerId
      cardId
      createdAt
      updatedAt
    }
  }
`;
export const listCardInfos = /* GraphQL */ `
  query ListCardInfos(
    $filter: ModelcardInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCardInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        userName
        email
        city
        region
        postalCode
        country
        phoneNo
        cardNum
        address
        customerId
        cardId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      total
      subTotal
      shipCharge
      customerId
      items {
        campaignId
        quantity
        size
        shirtName
        designShirt
        price
        colors
      }
      createdAt
      updatedAt
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelpaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        total
        subTotal
        shipCharge
        customerId
        items {
          campaignId
          quantity
          size
          shirtName
          designShirt
          price
          colors
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGarment = /* GraphQL */ `
  query GetGarment($id: ID!) {
    getGarment(id: $id) {
      id
      frontImg
      backImg
      frontImgaddress
      backImgaddress
      cost
      category {
        webflowId
        id
        categoryName
        name
      }
      garmentName {
        name
        id
      }
      garmentDescription
      color
      createdAt
      updatedAt
    }
  }
`;
export const listGarments = /* GraphQL */ `
  query ListGarments(
    $filter: ModelgarmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGarments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        frontImg
        backImg
        frontImgaddress
        backImgaddress
        cost
        category {
          webflowId
          id
          categoryName
          name
        }
        garmentName {
          name
          id
        }
        garmentDescription
        color
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      userId
      userName
      email
      paypalEmail
      accountNo
      ibanNo
      WebflowCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModeluserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        userName
        email
        paypalEmail
        accountNo
        ibanNo
        WebflowCustomerId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byUserId = /* GraphQL */ `
  query ByUserId(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModeluserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        userName
        email
        paypalEmail
        accountNo
        ibanNo
        WebflowCustomerId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($id: ID!) {
    getProductCategory(id: $id) {
      id
      categoryName
      webflowId
      createdAt
      updatedAt
    }
  }
`;
export const listProductCategorys = /* GraphQL */ `
  query ListProductCategorys(
    $filter: ModelproductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categoryName
        webflowId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
